var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.defaultData,"unique-opened":true,"text-color":"#333333","background-color":"#f3f3f3","active-text-color":"#1a82e3"},on:{"select":_vm.selectItem}},[_c('helpItem',{attrs:{"list-data":_vm.typeData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }